import loadable from '@loadable/component';

export default loadable(
  () => import(/* webpackChunkName: "mweb-bottom-nav" */ './components/BottomNavRender')
);
